// extracted by mini-css-extract-plugin
export default {"container":"Headers_container_KBwUT","date":"Headers_date_o7Me5","content":"Headers_content_mhL7k","column":"Headers_column_zUugF","edit":"Headers_edit_nO7fz"};